import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_field = _resolveComponent("field")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createBlock(_component_ion_grid, { class: "form-grid" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gridWithFields, (row, idx_row) => {
        return (_openBlock(), _createBlock(_component_ion_row, {
          key: idx_row + _ctx.stepId,
          class: _normalizeClass({ 'first-row': idx_row === 0, 'last-row': idx_row + 1 === _ctx.gridWithFields.length })
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, idx_col) => {
              return (_openBlock(), _createBlock(_component_ion_col, {
                key: '' + idx_col + idx_row + _ctx.stepId,
                "size-xs": _ctx.maxRespGridCols.toString(),
                "size-sm": _ctx.getFieldSize(col),
                class: _normalizeClass({ 'first-col': idx_col === 0, 'last-col': idx_col + 1 === row.length })
              }, {
                default: _withCtx(() => [
                  (col !== 'empty')
                    ? (_openBlock(), _createBlock(_component_field, {
                        data: col[1],
                        onValueChanged: _ctx.updateDataForField,
                        key: 'field_' + _ctx.stepId
                      }, null, 8, ["data", "onValueChanged"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["size-xs", "size-sm", "class"]))
            }), 128))
          ]),
          _: 2
        }, 1032, ["class"]))
      }), 128))
    ]),
    _: 1
  }))
}